<template>
  <div class="carousel-second">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="carousel-item"
      :style="{ backgroundImage: 'url(' + item.thumb + ')' }"
    >
      <div class="hover-background transition" />
      <div class="zIndex-1">
        <div class="item-vr transition" @click.stop="handleVr(item)">
          <img class="vr-icon" src="@/assets/images/vr-icon.png" />
          <div class="vr-label">360°VR</div>
          <div class="vr-tips">{{ $t("vr") }}</div>
        </div>
        <div class="item-title">{{ item.title }}</div>
        <div class="item-tips">{{ item.subtitle }}</div>
        <div class="item-animation">
          <div class="item-hr"></div>
          <div class="item-desc">
            {{ item.brief }}
          </div>
          <div class="item-help">
            <div class="help-item" @click.stop="toTraffic">
              <div class="help-icon transition traffic"></div>
              <div class="help-title transition">{{ $t("traffic") }}</div>
            </div>
            <div class="help-item" @click.stop="toFoodAccommodation">
              <div class="help-icon transition food"></div>
              <div class="help-title transition">{{ $t("food") }}</div>
            </div>
            <div class="help-item" @click.stop="toFoodAccommodation">
              <div class="help-icon transition accommodation"></div>
              <div class="help-title transition">{{ $t("accommodation") }}</div>
            </div>
            <div class="help-item" @click.stop="toConsult">
              <div class="help-icon transition consult"></div>
              <div class="help-title transition">{{ $t("consult") }}</div>
            </div>
          </div>
          <div class="item-btn">
            <div class="btn-item transition" @click="toDetail(item)">
              {{ $t("introduction") }}
            </div>
            <div class="btn-item transition" @click="toBooking">
              {{ $t("booking") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsPage } from "@/api/common";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    getNewsPage({ categoryId: "1838761598832078850" }).then((res) => {
      this.list = res.data.records;
    });
  },
  methods: {
    handleVr(row) {
      row.externalUrl && window.open(row.externalUrl);
    },
    // 景区交通
    toTraffic() {
      this.$router.push("/strategy/traffic-list");
    },
    // 美食、住宿
    toFoodAccommodation() {
      this.$router.push("/strategy/accommodation-list");
    },
    // 在线咨询
    toConsult() {
      this.$router.push("/consult/form");
    },
    // 详情
    toDetail(row) {
      this.$router.push("/introduction/detail?id=" + row.id);
    },
    // 预约购票
    toBooking() {
      window.open("https://yuyht.wgj.qz.gov.cn/static/qzmobile/");
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-second {
  width: 100%;
  height: 100%;
  display: flex;
  .carousel-item {
    flex: 1;
    width: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    .hover-background {
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0.6) 32.55%,
        rgba(0, 0, 0, 0) 80%
      );
      z-index: 0;
      opacity: 0;
      transition: all 1s;
    }
    .zIndex-1 {
      position: relative;
      padding: 0 80px;
      padding-top: 88px;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .item-vr {
      width: 160px;
      height: 160px;
      flex-shrink: 0;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.3);
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;
      margin-bottom: 52px;
      display: none;
      cursor: pointer;
      .vr-icon {
        width: 108px;
        display: block;
      }
      .vr-label {
        font-size: 20px;
        font-weight: 400;
      }
      .vr-tips {
        margin-top: 2px;
        font-size: 16px;
        font-weight: 400;
      }
    }
    .item-title {
      color: #fff;
      font-size: 48px;
      font-weight: 700;
      line-height: 26px; /* 54.167% */
      white-space: nowrap;
    }
    .item-tips {
      margin-top: 24px;
      color: #fff;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px; /* 144.444% */
    }
    .item-animation {
      display: none;
      opacity: 0;
      transition: all 1s;
    }
    .item-hr {
      width: 100%;
      margin-top: 27px;
      margin-bottom: 11px;
      height: 1px;
      background-color: #fff;
    }
    .item-desc {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      line-height: 36px; /* 225% */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 5; /* 显示的行数，可以根据需要修改 */
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .item-help {
      margin-top: 30px;
      width: 100%;
      display: flex;
      .help-item {
        flex: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.24);
        padding: 17px 0;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .help-icon {
          width: 34px;
          height: 34px;
          background-repeat: no-repeat;
          background-size: 100%;
          &.traffic {
            background-image: url(@/assets/images/index/help/traffic.png);
          }
          &.food {
            background-image: url(@/assets/images/index/help/food.png);
          }
          &.accommodation {
            background-image: url(@/assets/images/index/help/accommodation.png);
          }
          &.consult {
            background-image: url(@/assets/images/index/help/consult.png);
          }
        }
        .help-title {
          margin-top: 6px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px; /* 185.714% */
          text-align: center;
        }
        &:hover {
          .help-title {
            color: #009d94;
          }
          .traffic {
            background-image: url(@/assets/images/index/help/traffic-hover.png);
          }
          .food {
            background-image: url(@/assets/images/index/help/food-hover.png);
          }
          .accommodation {
            background-image: url(@/assets/images/index/help/accommodation-hover.png);
          }
          .consult {
            background-image: url(@/assets/images/index/help/consult-hover.png);
          }
        }
        + .help-item {
          margin-left: 24px;
        }
      }
    }
    .item-btn {
      width: 100%;
      margin-top: 72px;
      display: flex;
      .btn-item {
        flex: 1;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        border: 1px solid #fff;
        cursor: pointer;
        &:hover {
          color: #009d94;
          background-color: #fff;
        }
        + .btn-item {
          margin-left: 24px;
        }
      }
    }

    &:hover {
      .hover-background {
        opacity: 1;
      }

      .item-vr {
        display: flex;
        opacity: 1;
        animation: show 1s;
      }
      .item-animation {
        display: unset;
        opacity: 1;
        animation: show 1s;
      }
    }
  }
}

@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
